import React from 'react';
import styles from './MasterdataHeader.module.css';

export const MasterdataHeader: React.FC = ({ children }) => {
  return <div className={styles.MasterdataHeader}>{children}</div>;
};
